const INTERNAL_SESSION_FILE_REF_RE = /^(artifact-)?(cfile|file)[-_][a-z0-9]+$/i
// The document/deck renderer rasterizes each page for the model's visual self-QA
// (`preview/page-1.png`, `preview/slide-1.png`) and the backend stores them as
// `preview_page-1.png` / `preview_slide-1.png`. They are registered in the
// session's file_refs only so /api/session-content serves them to the deck card;
// they are not deliverables and must never become file context for the next
// message (#3322). Kept in sync with safe_upload_filename in
// app/backend/tools/_shared/code_runner_artifacts.py.
const RENDERER_PREVIEW_FILE_REF_RE = /^preview_(page|slide)-\d+\.(png|jpe?g)$/i

function normalizeFilename(value: string): string {
  const base = value.split(/[?#]/)[0]
  const parts = base.split("/")
  return (parts[parts.length - 1] ?? base).trim()
}

function isInternalSessionFileRef(filename: string): boolean {
  if (!filename || typeof filename !== "string") return false
  const normalized = normalizeFilename(filename)
  if (!normalized) return false
  return (
    INTERNAL_SESSION_FILE_REF_RE.test(normalized) || RENDERER_PREVIEW_FILE_REF_RE.test(normalized)
  )
}

export function filterSessionFileRefs(fileRefs: string[]): string[] {
  if (!Array.isArray(fileRefs)) return []
  return fileRefs.filter((ref) => !isInternalSessionFileRef(ref))
}
